<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>{{dialogTitle}}</div>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>
  <div class="v-box full-height mark-frame">
    <div *ngIf="hasGoalId" class="goal-mark"><ion-icon name="rocket-outline"></ion-icon></div>
    <div *ngIf="contentInfo != ''" class="contentInfo">{{contentInfo}}</div>
    <div *ngIf="parsedDescription != ''" class="markdown-description" [innerHTML]="parsedDescription" (click)="interceptClick($event)"></div>
    <rich-text *ngIf="parsedDescription == '' && dialogDescription != ''" [text]="dialogDescription"></rich-text>
  </div>
</ion-content>

<ion-footer class="ion-padding page2">
    <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" (click)="onNextClick()"><div translate>COMMON.NEXT</div></ion-button>
</ion-footer>
